module.exports = __webpack_public_path__ + "../resources/img/storebadge_it.c701b48c.png";